/* eslint-disable max-len */
import MarkerColorEnum from '~/components/map/types/marker/MarkerColorEnum';
import markerMetrics from '~/consts/markeryMetrics';

const buildReusableMarkerSvgUrl = (iconBase64: string): string => {
  const { defaultMarkerBiura: metrics } = markerMetrics;
  const fillColor: string = MarkerColorEnum.BIURO;

  return `data:image/svg+xml;utf-8,
  <svg height="${metrics.main.height}" width="${metrics.main.width}" xmlns="http://www.w3.org/2000/svg">
  <rect y="${metrics.image.containerY}" x="${metrics.image.containerX}" height="${metrics.image.containerHeight}" width="${
  metrics.image.containerWidth
}" rx="${metrics.image.containerRadius}" fill="${fillColor}"></rect>
  <image width="${metrics.image.width}" height="${metrics.image.height}" x="${metrics.image.x}" y="${
  metrics.image.y
}" href="${iconBase64}"/>
  <g transform="translate(${metrics.triangle.x},${metrics.triangle.y})">
    <svg>
      <polygon fill="${fillColor}" points="0,0 ${metrics.triangle.size * 2},0, ${metrics.triangle.size},${metrics.triangle.size}" />
    </svg>
  </g>
  <circle cx="${metrics.point.x}" cy="${metrics.point.y}" r="${metrics.point.size / 2}" fill="${fillColor}"/>
  <image width="${metrics.point.checkSize}" height="${metrics.point.checkSize}" x="${metrics.point.checkX}" y="${metrics.point.checkY}" />
</svg>`;
};
export default buildReusableMarkerSvgUrl;
